import type { FaireProductEntity } from "../../entity_types/product";

export const p_8eyawnjana: FaireProductEntity = {
  token: "p_8eyawnjana",
  type: "product",
  name: "ROMA Vintage Mini Babydoll Dress",
  brandToken: "b_afmk8knmga",
  brandName: "Urlazh",
  imageUrl:
    "https://cdn.faire.com/fastly/64524e5c70d0d2eef15a0c82d7442319257ab45ca004066ff6ba9ead4b184afc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b12b75382d79c8682279c1a05b0bd6f6f67348c13e2098df9f363fde43150522.jpeg",
    "https://cdn.faire.com/fastly/eb04a8169b49dbc61cc8b9eb93fa0e50d468aef0e209e3786c13245cb1bf0a7b.jpeg",
    "https://cdn.faire.com/fastly/7f9790f1bd7683df6e49a43f3d1eb6bf6e43dc3eb42c671accf0280a5b5e1625.jpeg",
    "https://cdn.faire.com/fastly/fafc2d96d246cef4a1bbba2c0e92d813084d9dec641af6068d193b2fcdaa5550.jpeg",
  ],
  priceDollars: 135.5,
  description:
    "• Mini babydoll dress in black\n• Square collar\n• Ruffled cap-sleeve\n• Self-tie fastening at back neck\n• Ribbon trim at front\n\n𝐌𝐚𝐭𝐞𝐫𝐢𝐚𝐥𝐬 & 𝐂𝐚𝐫𝐞:\n\n• 93.6% Polyester, 6.4% Spandex\n• Material 2: 100% Mulberry Silk\n• Hand wash | Dry clean\n• Do not bleach\n\n𝐒𝐢𝐳𝐞 & 𝐅𝐢𝐭:\n\n• Model is 5'7\", Bust 32, Waist 24, Hips 35, wearing a size S\n\n\n\n*This item is final sale*\n\n\n\nItem #: PL1DR01",
  tags: [],
  msrpDollars: 271,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:20:06.749Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
